const regForm = {
  state: {
    formStep: "START",
    formData: {
      orgNameInternal: "Stockholms stad",
      orgCityInternal: "Stockholm",
      orgPostalCodeInternal: "120 21",
      orgAddressInternal: "Box 901111",
    },
    tixlyTagIds: ["901", "902", "903", "904", "905", "906", "907", "912"],
  },
  getters: {
    getFormStep: (state) => state.formStep,
    getFormData: (state) => state.formData,
    getAccountTypeID: (state) => {
      switch (state.formData.accountType) {
        case "private":
          return "901";
        case "company":
          return "906";
        case "school":
          return "907";
        default:
          return "912";
      }
    },
    getAccountInfo: (state) => state.accountInfo,
    hasUserTags: (state) => {
      return state.formData.userTags && state.formData.userTags.length > 0;
    },
  },
  mutations: {
    SET_FORM_STEP(state, value) {
      state.formStep = value;
    },
    SET_FORM_STEP_LOADING(state) {
      state.formStep = "LOADING";
    },
    SET_FORM_DATA(state, value) {
      state.formData = { ...state.formData, ...value };
    },
    CLEAR_FORM_DATA(state) {
      state.formData = { accountType: state.formData.accountType };
    },
    REMOVE_FORM_DATA(state, value) {
      let tempState = { ...state.formData };
      Object.keys(value).forEach((key) => {
        delete tempState[key];
      });
      state.formData = tempState;
    },
  },
  actions: {
    setFormStep({ commit }, value) {
      commit("SET_FORM_STEP", value);
      if (value === "START") {
        commit("CLEAR_FORM_DATA");
      }
    },
    setFormStepLoading({ commit }) {
      commit("SET_FORM_STEP_LOADING");
    },
    setFormData({ commit }, value) {
      commit("SET_FORM_DATA", value);
    },
    removeFormData({ commit }, value) {
      commit("REMOVE_FORM_DATA", value);
    },
    async saveCustomerTag({ commit, state }, value) {
      let tixlyData = {};
      if (
        state.formData.accountType === "company" &&
        state.formData.companyType === "external"
      ) {
        tixlyData = {
          CompanyName: state.formData.orgName,
          CRN: state.formData.orgValue,
          Metadata: [
            {
              Name: "InvoiceAddress",
              Value: state.formData.orgAddress,
              CustomerAttributeID: 12,
            },
            {
              Name: "InvoiceZip",
              Value: state.formData.orgPostalCode,
              CustomerAttributeID: 14,
            },
            {
              Name: "InvoiceCity",
              Value: state.formData.orgCity,
              CustomerAttributeID: 15,
            },
            {
              Name: "InvoiceCountry",
              Value: state.formData.orgCountry,
              CustomerAttributeID: 16,
            },
            {
              Name: "InvoiceRefNo1",
              Value: state.formData.yourReference,
              CustomerAttributeID: 17,
            },
            {
              Name: "InvoiceEmail",
              Value: state.formData.digitalInvoiceEmail,
              CustomerAttributeID: 19,
            },
            {
              Name: "InvoiceName",
              Value: state.formData.nameOnInvoice,
              CustomerAttributeID: 22,
            },
          ],
        };
      } else if (
        state.formData.accountType === "company" &&
        state.formData.companyType === "internal"
      ) {
        tixlyData = {
          CompanyName: state.formData.orgNameIntern,
          CRN: state.formData.orgNumber,
          Metadata: [
            {
              Name: "InvoiceAddress",
              Value: state.formData.customerId,
              CustomerAttributeID: 12,
            },
            {
              Name: "InvoiceAddressTwo",
              Value: state.formData.orgAddressInternal,
              CustomerAttributeID: 13,
            },
            {
              Name: "InvoiceZip",
              Value: state.formData.orgPostalCodeInternal,
              CustomerAttributeID: 14,
            },
            {
              Name: "InvoiceCity",
              Value: state.formData.orgCityInternal,
              CustomerAttributeID: 15,
            },
            {
              Name: "InvoiceRefNo2",
              Value: state.formData.yourReferenceInternalComp,
              CustomerAttributeID: 18,
            },
            {
              Name: "InvoiceName",
              Value: state.formData.orgNameInternal,
              CustomerAttributeID: 22,
            },
          ],
        };
      } else if (
        state.formData.accountType === "school" &&
        state.formData.schoolType === "external"
      ) {
        tixlyData = {
          CompanyName: state.formData.orgName,
          Metadata: [
            {
              Name: "InvoiceAddress",
              Value: state.formData.orgAddress,
              CustomerAttributeID: 12,
            },
            {
              Name: "InvoiceZip",
              Value: state.formData.orgPostalCode,
              CustomerAttributeID: 14,
            },
            {
              Name: "InvoiceCity",
              Value: state.formData.orgCity,
              CustomerAttributeID: 15,
            },
            {
              Name: "InvoiceCountry",
              Value: state.formData.orgCountry,
              CustomerAttributeID: 16,
            },
            {
              Name: "InvoiceRefNo1",
              Value: state.formData.yourReference,
              CustomerAttributeID: 17,
            },
            {
              Name: "InvoiceEmail",
              Value: state.formData.digitalInvoiceEmail,
              CustomerAttributeID: 19,
            },
            {
              Name: "InvoiceName",
              Value: state.formData.nameOnInvoice,
              CustomerAttributeID: 22,
            },
          ],
        };
      } else if (
        state.formData.accountType === "school" &&
        state.formData.schoolType === "internal"
      ) {
        tixlyData = {
          CRN: "2120000142",
          CompanyName: state.formData.schoolNameInternal,
          Metadata: [
            {
              Name: "InvoiceAddress",
              Value: "Kund-ID STH 117",
              CustomerAttributeID: 12,
            },
            {
              Name: "InvoiceAddressTwo",
              Value: state.formData.orgAddressInternal,
              CustomerAttributeID: 13,
            },
            {
              Name: "InvoiceZip",
              Value: state.formData.orgPostalCodeInternal,
              CustomerAttributeID: 14,
            },
            {
              Name: "InvoiceCity",
              Value: state.formData.orgCityInternal,
              CustomerAttributeID: 15,
            },
            {
              Name: "InvoiceRefNo2",
              Value: state.formData.schoolReferenceInternal,
              CustomerAttributeID: 18,
            },
            {
              Name: "InvoiceName",
              Value: state.formData.orgNameInternal,
              CustomerAttributeID: 22,
            },
            {
              Name: "CustomerIDAgresso",
              Value: 117,
              CustomerAttributeID: 20,
            },
            {
              Name: "Counterpart",
              Value: 1117,
              CustomerAttributeID: 23,
            },
          ],
        };
      }

      const khst_user_csrf_token = window.khstGetUser()?.csrf_token;
      if (!khst_user_csrf_token) {
        return;
      }

      const response = await fetch("/api/v2/edit-account?format=json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": khst_user_csrf_token,
        },
        body: JSON.stringify({
          tag_id: value,
          tag_id_removed: state.tixlyTagIds
            .filter((item) => item !== value)
            .join(","),
          ...tixlyData,
          FirstName: state.formData.accountInfoFirstName,
          LastName: state.formData.accountInfoLastName,
          Email: state.formData.accountInfoMail,
          StreetName: state.formData.accountInfoAddress,
          ZipCode: state.formData.accountInfoPostalCode,
          Country: state.formData.accountInfoCountry,
          City: state.formData.accountInfoCity,
          Mobile: state.formData.accountInfoPhone,
        }),
      });
      const data = await response.json();
    },
    async addCustomerTag({ commit, state }, accountData) {
      const khst_user_csrf_token = window.khstGetUser()?.csrf_token;
      if (!khst_user_csrf_token) {
        return;
      }

      const response = await fetch("/api/v2/edit-account?format=json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": khst_user_csrf_token,
        },
        body: JSON.stringify({
          tag_id: state.formData.accountType === "school" ? 902 : 904,
        }),
      });
      const data = await response.json();
    },
    async addCustomerLocationTag({ commit, state }, accountData) {
      const tagId =
        state.formData.accountType === "school"
          ? state.formData.schoolType === "internal"
            ? 251
            : 252
          : state.formData.companyType === "internal"
          ? 251
          : 252;

      const khst_user_csrf_token = window.khstGetUser()?.csrf_token;
      if (!khst_user_csrf_token) {
        return;
      }

      const response = await fetch("/api/v2/edit-account?format=json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": khst_user_csrf_token,
        },
        body: JSON.stringify({
          tag_id: tagId,
        }),
      });
      const data = await response.json();
    },
    async updateAccountInfo({ commit, state }, accountData) {
      const khst_user_csrf_token = window.khstGetUser()?.csrf_token;
      if (!khst_user_csrf_token) {
        return;
      }

      const response = await fetch("/api/v2/edit-account?format=json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": khst_user_csrf_token,
        },
        body: JSON.stringify(accountData),
      });

      const data = await response.json();
      return data;
    },
    async updateInvoiceInfo({ commit, state }, invoiceData) {
      const khst_user_csrf_token = window.khstGetUser()?.csrf_token;
      if (!khst_user_csrf_token) {
        return;
      }

      const response = await fetch("/api/v2/edit-account?format=json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": khst_user_csrf_token,
        },
        body: JSON.stringify(invoiceData),
      });

      const data = await response.json();
      return data;
    },
    async getAccountInfo({ commit, dispatch, state }, value) {
      const khst_user_csrf_token = window.khstGetUser()?.csrf_token;
      if (!khst_user_csrf_token) {
        return;
      }

      const response = await fetch("/api/v2/user-account?format=json", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": khst_user_csrf_token,
        },
      });
      const data = await response.json();
      const countryCodeMapping = {
        Sweden: "SE",
        Denmark: "DK",
        Norway: "NO",
        Finland: "FI",
        Iceland: "IS",
      };
      await dispatch("setFormData", {
        accountInfoFirstName:
          data["result"]["tix_user_data"]["FirstName"] || "",
        accountInfoLastName: data["result"]["tix_user_data"]["LastName"] || "",
        accountInfoMail: data["result"]["email"] || "",
        accountInfoAddress: data["result"]["tix_user_data"]["AddressOne"] || "",
        accountInfoPostalCode: data["result"]["tix_user_data"]["ZipCode"] || "",
        accountInfoCity: data["result"]["tix_user_data"]["City"] || "",
        accountInfoCountry:
          countryCodeMapping[data["result"]["tix_user_data"]["Country"]] || "",
        accountInfoPhone: data["result"]["tix_user_data"]["Mobile"] || "",
        orgName: data["result"]["tix_user_data"]["CompanyName"] || "",
        userTags: data["result"]["tix_user_data"]["Tags"] || [],
        orgNumber: data["result"]["tix_user_data"]["CRN"] || "",
        orgValue: data["result"]["tix_user_data"]["CRN"] || "",
        orgNameIntern: data["result"]["tix_user_data"]["CompanyName"] || "",
        schoolNameInternal:
          data["result"]["tix_user_data"]["CompanyName"] || "",
        customerId:
          state.formData.accountType === "company"
            ? data["result"]["tix_user_data"]["Metadata"].find(
                (item) => item.Name === "InvoiceAddress"
              )?.Value
            : "Kund-ID STH 117",
        orgAddress:
          data["result"]["tix_user_data"]["Metadata"].find(
            (item) => item.Name === "InvoiceAddress"
          )?.Value || "",
        orgPostalCode:
          data["result"]["tix_user_data"]["Metadata"].find(
            (item) => item.Name === "InvoiceZip"
          )?.Value || "",
        orgCity:
          data["result"]["tix_user_data"]["Metadata"].find(
            (item) => item.Name === "InvoiceCity"
          )?.Value || "",
        orgCountry:
          data["result"]["tix_user_data"]["Metadata"].find(
            (item) => item.Name === "InvoiceCountry"
          )?.Value || "",
        nameOnInvoice:
          data["result"]["tix_user_data"]["Metadata"].find(
            (item) => item.Name === "InvoiceName"
          )?.Value || "",
        digitalInvoiceEmail:
          data["result"]["tix_user_data"]["Metadata"].find(
            (item) => item.Name === "InvoiceEmail"
          )?.Value || "",
        yourReference:
          data["result"]["tix_user_data"]["Metadata"].find(
            (item) => item.Name === "InvoiceRefNo1"
          )?.Value || "",
        yourReferenceSchool:
          data["result"]["tix_user_data"]["Metadata"].find(
            (item) => item.Name === "InvoiceRefNo2"
          )?.Value || "",
        schoolReferenceInternal:
          data["result"]["tix_user_data"]["Metadata"].find(
            (item) => item.Name === "InvoiceRefNo2"
          )?.Value || "",
        yourReferenceInternalComp:
          data["result"]["tix_user_data"]["Metadata"].find(
            (item) => item.Name === "InvoiceRefNo2"
          )?.Value || "",
      });
    },

    async getExternalInfo({ commit, dispatch, state }, value) {
      let fetchUrl;
      if (
        state.formData.accountType === "company" &&
        state.formData.companyType === "external"
      ) {
        fetchUrl = `/api/v2/bolagsverket/organisationer?organisationnumber=${value
          .replace(/\D/g, "")
          .trim()}`;
      } else if (state.formData.accountType === "school") {
        fetchUrl = `/api/v2/schoolunit/information?schoolUnitCode=${value
          .replace(/\D/g, "")
          .trim()}`;
      } else if (state.formData.accountType === "private") {
        fetchUrl = `/api/v2/skolverket/information?organisationnumber=${value
          .replace(/\D/g, "")
          .trim()}`;
      }

      if (!fetchUrl) {
        return;
      }

      await dispatch("setFormData", {
        orgName: "",
        orgAddress: "",
        orgPostalCode: "",
        orgCity: "",
        orgCountry: "",
        orgLookupError: "",
        orgLookupSuccess: false,
      });

      const response = await fetch(fetchUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      if (
        state.formData.accountType === "company" &&
        state.formData.companyType === "external"
      ) {
        const org = data.organisation_data?.[0];
        if (!org || !org.organisationsnamn?.namn) {
          await dispatch("setFormData", {
            orgLookupError: "Kunde inte hitta organisationen med detta organisationsnummer. Kontrollera organisationsnumret och försöka igen.",
          });
          return;
        }
        await dispatch("setFormData", {
          orgName: org.organisationsnamn.namn,
          orgAddress:
            org.organisationsadresser?.postadress?.adress ||
            org.organisationsadresser?.postadress?.coAdress,
          orgPostalCode: org.organisationsadresser?.postadress?.postnummer,
          orgCity: org.organisationsadresser?.postadress?.postort,
          orgCountry: "Sverige",
          orgLookupError: "",
        });
      } else if (state.formData.accountType === "private") {
        const huvudman = data.organisation_data?.Huvudman;
        if (!huvudman) {
          await dispatch("setFormData", {
            orgLookupError: "Kunde inte hitta organisationen med detta organisationsnummer. Kontrollera organisationsnumret och försöka igen.",
          });
          return;
        }
        await dispatch("setFormData", {
          orgName: huvudman.Namn,
          orgAddress: huvudman.Utdelningsadress?.Adress,
          orgPostalCode: huvudman.Utdelningsadress?.Postnr,
          orgCity: huvudman.Utdelningsadress?.Ort,
          orgCountry: "Sverige",
          orgLookupError: "",
        });
      } else if (state.formData.accountType === "school") {
        const schoolUnit = data.school_unit_data?.data?.attributes;
        if (!schoolUnit) {
          await dispatch("setFormData", {
            orgLookupError: "Kunde inte hitta skolan med denna enhetskod. Kontrollera enhetskoden och försök igen.",
          });
          return;
        }
        await dispatch("setFormData", {
          orgName: schoolUnit.schoolName,
          orgAddress: schoolUnit.addresses?.[2]?.streetAddress,
          orgPostalCode: schoolUnit.addresses?.[2]?.postalCode,
          orgCity: schoolUnit.addresses?.[2]?.locality,
          orgCountry: "Sverige",
          orgLookupError: "",
        });
      }
    },
  },
};
export default regForm;
